export default __webpack_public_path__ + "static/media/separator.c7d3e62f.png";